export default "__VITE_ASSET__yPIIdXU6y9Ly12lnB3YDIw__"